import type { FileExportKind } from "@/object-actions/fileRecordExportCatalog";
import {
  classifyFileRecord,
  fileRecordDownloadBasename,
  getFileRecordName,
} from "@/panes/file-record-detail/contentType";
import {
  fetchFileRecordTextBody,
  runExportFromFetchedBody,
} from "@/panes/file-record-detail/fileRecordExportRunner";
import type { FileRecord } from "@cohesive/api-client";

export type RemoteFileRecordDownloadFn = (
  downloadUrl: string | undefined,
  fileName?: string,
) => Promise<void>;

export function createRemoteFileRecordExportRunner(
  record: FileRecord,
  download: RemoteFileRecordDownloadFn,
) {
  const kind = classifyFileRecord(record);
  const baseName = fileRecordDownloadBasename(record);
  const displayFileName = getFileRecordName(record) || record.id;

  const isVariantDisabled = (format: FileExportKind): boolean => {
    if (format === "original") {
      return !record.download_url;
    }
    return !record.url;
  };

  const runExport = async (format: FileExportKind) => {
    if (format === "original") {
      await download(record.download_url, displayFileName);
      return;
    }
    const body = await fetchFileRecordTextBody(record);
    await runExportFromFetchedBody({ kind, format, baseName, body });
  };

  return { kind, runExport, isVariantDisabled };
}
